<template>
  <div class="section-header">
    <div class="subtitle">{{ subtitle }}</div>
    <component :is="tag" class="title">{{ title }}</component>
  </div>
</template>

<script>
export default {
  name: 'SectionHeader',
  props: {
    title: {
      type: String,
      default: null
    },
    subtitle: {
      type: String,
      default: null
    },
    // 這個元件在首頁等版面會重複出現，預設仍輸出 div，避免一頁冒出多個 h1。
    // 該段落是整頁主題時(分類頁、門市頁…)才由使用端指定 tag="h1"。
    tag: {
      type: String,
      default: 'div'
    }
  }
}
</script>

<style scoped>
.title {
  font-size: 2.75rem;
  font-weight: 700;
  font-family: 'Noto Serif TC', serif;
  /* 標籤換成 h1 後要蓋掉瀏覽器預設的 margin，版面才不會跑掉 */
  margin: 0;
}
.subtitle {
  font-family: 'Noto Serif TC', serif;
}
</style>
